export const patientDetailsCardSelectors = {
  container: (patientId: number) => `patient-details-card-${patientId}`
};
